import React from 'react';

/**
 * Returns the millisecond duration since `startedAt`, ticking every second while
 * the period is in progress. When `endedAt` is provided, returns the static final
 * duration without scheduling a timer.
 *
 * Use for live-updating elapsed time displays inside the conversation timeline.
 */
export const useLiveElapsed = (
  startedAt: string | Date | null | undefined,
  endedAt?: string | Date | null
): number => {
  const startMs = startedAt ? new Date(startedAt).getTime() : null;
  const endMs = endedAt ? new Date(endedAt).getTime() : null;
  const isLive = startMs != null && endMs == null;

  const [now, setNow] = React.useState(() => Date.now());

  React.useEffect(() => {
    if (!isLive) return undefined;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [isLive]);

  if (startMs == null) return 0;
  if (endMs != null) return Math.max(0, endMs - startMs);
  return Math.max(0, now - startMs);
};
